import { isRejectedWithValue } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const getErrorMessage = (status, data) => {
  switch (status) {
    case 400:
    case 404:
      if (data?.errors && typeof data.errors === "object") {
        const errorMessages = Object.entries(data.errors).reduce(
          (acc, [field, messages]) => {
            acc[field] = Array.isArray(messages)
              ? messages.join(", ")
              : messages;
            return acc;
          },
          {}
        );
        return errorMessages;
      } else if (data?.error && typeof data.error === "object") {
        const errorMessages = Object.entries(data.error).reduce(
          (acc, [field, messages]) => {
            acc[field] = Array.isArray(messages)
              ? messages.join(", ")
              : messages;
            return acc;
          },
          {}
        );
        return errorMessages;
      } else if (data?.errors && typeof data.errors === "string") {
        return { general: data.errors };
      } else if (data?.error && typeof data.error === "string") {
        return { general: data.error };
      }
      return { general: "Bad Request. Please check your input." };
    case 401:
      return { general: "Unauthorized! Please log in again." };
    case 403:
      return {
        general:
          (typeof data?.error === "string" && data.error) ||
          data?.message ||
          "You don't have permission to perform this action.",
      };
    case 500:
      return {
        general:
          (typeof data?.error === "string" && data.error) ||
          data?.message ||
          "Internal Server Error. Please try again later.",
      };
    case 503:
      return {
        general:
          (typeof data?.error === "string" && data.error) ||
          data?.message ||
          "Service unavailable. Please try again later.",
      };
    case "FETCH_ERROR":
      return {
        general:
          "Cannot reach the API server. Start ngrok (or check NEXT_PUBLIC_API_URL) and restart the frontend.",
      };
    default:
      return {
        general:
          (typeof data?.error === "string" && data.error) ||
          data?.message ||
          "An error occurred. Please try again.",
      };
  }
};

const showError = (message) => {
  const show =
    message === "The link has been expired." ||
    message === "An error occurred. Please try again." ||
    (typeof message === "string" && message.startsWith("Cannot reach the API server"));
  if (show) {
    toast.error(message);
  }
};

export const apiErrorMiddleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { status, data } = action.payload || {};

    const errorMessages = getErrorMessage(status, data);
    if (errorMessages.general) {
      showError(errorMessages.general);
    }

    if (status === 400 && errorMessages) {
      store.dispatch({
        type: "form/setFieldErrors",
        payload: errorMessages,
      });
    }
  }

  return next(action);
};
